<template>
<div :class="classObj" class="app-wrapper">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar @getDrawer="getDrawer" class="sidebar-container" />
    <changeSystem :drawer="drawer" />
    <div class="main-container">
        <navbar />
        <tags />
        <app-main />
    </div>
</div>
</template>

<script>
import changeSystem from '@/components/changeSystem'
import {
  Navbar,
  Sidebar,
  AppMain,
  Tags
} from './components'
import ResizeMixin from './mixin/ResizeHandler'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    Tags,
    changeSystem
  },
  data() {
    return {
      drawer: false
    }
  },

  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    // 改变抽屉状态
    getDrawer(v) {
      console.log('sdasdxv', v)
      this.drawer = v
    },
    handleClickOutside() {
      this.$store.dispatch('closeSideBar', {
        withoutAnimation: false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";

.app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
        position: fixed;
        top: 0;
    }
}

/deep/.drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
}
</style>
